import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, Package, Mail, LogOut, ExternalLink, Settings } from "lucide-react";
import { getToken, getUser, clearSession, me } from "../../lib/auth";
import Logo from "../../components/Logo";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/produtos", label: "Produtos", icon: Package },
  { to: "/admin/contatos", label: "Contatos", icon: Mail },
  { to: "/admin/conteudo", label: "Conteúdo", icon: Settings },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [user, setUser] = useState(getUser());
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      setChecking(false);
      return;
    }
    me()
      .then((u) => setUser(u))
      .catch(() => {
        clearSession();
        navigate("/admin/login", { replace: true });
      })
      .finally(() => setChecking(false));
  }, [navigate]);

  if (!getToken()) return <Navigate to="/admin/login" replace />;

  const onLogout = () => {
    clearSession();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F9F9F9] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#0F0F10] text-white flex flex-col sticky top-0 h-screen">
        <div className="p-6 border-b border-white/10">
          <Logo variant="light" size={32} />
        </div>
        <nav className="flex-1 py-4">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3.5 text-sm font-bold uppercase tracking-[0.12em] border-l-2 transition-colors ${
                  isActive
                    ? "border-[#E84E34] text-white bg-white/5"
                    : "border-transparent text-white/60 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <n.icon size={18} strokeWidth={1.8} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-6 border-t border-white/10 space-y-3">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-xs text-white/60 hover:text-white"
            data-testid="admin-view-site"
          >
            <ExternalLink size={14} /> Ver site
          </a>
          <div className="text-[11px] text-white/40 font-mono-sm tracking-wider truncate">
            {user?.email}
          </div>
          <button
            onClick={onLogout}
            data-testid="admin-logout"
            className="w-full inline-flex items-center justify-center gap-2 bg-transparent border border-white/20 text-white text-xs font-bold uppercase tracking-[0.18em] py-3 hover:bg-[#E84E34] hover:border-[#E84E34] transition-colors"
          >
            <LogOut size={14} /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        {checking ? (
          <div className="p-12 text-[#6B7280] font-mono-sm text-sm">Carregando...</div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
